import { useState } from 'react';
import { Dialog, DialogPanel } from '@headlessui/react';
import IconSvg from 'src/assets/icons/IconSvg';
import Button from 'src/components/button/Button';

interface Props {
  isOpen: boolean;
  close: () => void;
  onSubmit: (reason: string) => Promise<boolean>;
}

const ReportRaffleModal = ({ isOpen, close, onSubmit }: Props) => {
  const [reason, setReason] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!reason.trim()) return;
    setIsSubmitting(true);
    const success = await onSubmit(reason.trim());
    setIsSubmitting(false);
    if (success) {
      setReason('');
      close();
    }
  };

  return (
    <Dialog open={isOpen} as="div" className="relative z-50 focus:outline-none" onClose={close}>
      <div className="fixed inset-0 bg-[#1B1B1F99] backdrop-blur-[6.3px]" />

      <div className="overflow-y-auto fixed inset-0 w-screen">
        <div className="flex justify-center items-center min-h-full p-4">
          <DialogPanel className="w-full max-w-[520px] rounded-lg bg-grayscale-900 p-6 xl:p-8 relative">
            <button className="absolute top-5 right-5" onClick={close}>
              <IconSvg icon="closeM" className="text-grayscale-400" />
            </button>

            <div className="flex flex-col items-center text-center mb-6">
              <div className="mb-4 text-system-error">
                <IconSvg icon="reportM" />
              </div>

              <h3 className="text-brand-magnolia text-[22px] xl:text-[24px] mb-2">
                Report a Raffle and/or Creator
              </h3>

              <p className="text-sm text-grayscale-400">
                If you believe this raffle or its creator is engaging in suspicious or fraudulent
                activity, please describe the issue below.
              </p>
            </div>

            <textarea
              value={reason}
              onChange={e => setReason(e.target.value)}
              placeholder="Describe the issue briefly."
              className="w-full h-[120px] p-4 rounded-lg bg-grayscale-800 border border-grayscale-700 text-brand-magnolia placeholder:text-grayscale-500 text-sm resize-none focus:outline-none focus:border-brand-tangerine"
            />

            <Button
              variant="primary"
              size="sm"
              className="w-full mt-4"
              onClick={handleSubmit}
              disabled={!reason.trim() || isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Submit Report'}
            </Button>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default ReportRaffleModal;
